<template>
  <div class="bubble-chart-container container" :id="`bubble-chart-container-${chartId}`">
    <h2>{{ title }}</h2>
    <svg height="500" :id="`bubble-chart-${chartId}`"></svg>
  </div>
</template>

<script>
import * as d3 from 'd3'
import axios from 'axios'
export default {
  props: {
    dataUrl: {
      type: String,
      default: ''
    },
    chartId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      title: '',
      chartData: {}
    }
  },
  mounted () {
    this.getChartData()

    window.addEventListener('resize', () => {
      this.generateChart()
    })
  },
  methods: {
    /**
     * Used to retrieve chart data from URL
     */
    getChartData () {
      axios.get(this.dataUrl).then((response) => {
        this.title = response.data.title
        // Format received data
        this.chartData = { children: response.data.data }
        this.generateChart()
      }).catch((err) => {
        console.log(err)
      })
    },
    /**
     * Generate chart with d3
     */
    generateChart () {
      const graphicElement = document.getElementById(`bubble-chart-container-${this.chartId}`)
      const styles = window.getComputedStyle(graphicElement)
      const graphicPadding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight)
      const diameter = graphicElement.clientWidth - graphicPadding
      const color = '#98caff'

      let fontSize = 12
      if (diameter < 540) {
        fontSize = 10
      }

      const bubble = d3.pack(this.chartData)
        .size([diameter, diameter])
        .padding(1.5)

      d3.select(`#bubble-chart-${this.chartId}`).html('')

      const svg = d3.select(`#bubble-chart-${this.chartId}`)
        .attr('width', diameter)
        .attr('height', diameter)
        .attr('class', 'bubble')
      
      const nodes = d3.hierarchy(this.chartData)
        .sum((d) => {return d.value })
      
      const node = svg.selectAll('.node')
        .data(bubble(nodes).descendants())
        .enter()
        .filter((d) => {
          return !d.children
        })
        .append('g')
        .attr('class', 'node')
        .attr('transform', (d) => {
          return `translate(${d.x - (diameter * 0.05)},${d.y})` // TODO: Make this 0.05 adjustment a variable
        })

      node.append('circle')
        .attr('r', (d) => {
          return d.r
        })
        .style('fill', color)
      
      node.append('text')
        .attr('dy', '0em')
        .style('text-anchor', 'middle')
        .text((d) => {
          return d.data.name
        })
        .attr('font-size', `${fontSize}px`)
      
      node.append('text')
        .attr('dy', '1em')
        .style('text-anchor', 'middle')
        .text((d) => {
          return d.data.value + 'B'
        })
        .attr('font-size', `${fontSize}px`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
svg {
  display: block;
  margin: 0 auto;
}
</style>
